<div class="page-footer">
    <div class="text-center">
        <span>MGIS © {{copy | date:'yyyy'}}</span> <span *ngIf="buildNumber"><a href="{{buildURI}}"
                target="_blank">{{buildNumber}}</a></span>
    </div>
</div>